'use strict';

const $ = require('jquery');

window.$ = $;

window.jQuery = $;

require('bootstrap/dist/js/bootstrap.min');

import bootbox from 'bootbox';

import 'photoswipe/dist/photoswipe-ui-default.min.js';

import 'photoswipe/dist/photoswipe.min.js';

import 'slick-carousel/slick/slick.js';

import 'select2/dist/js/select2.full.min.js';

import 'selectize/dist/js/standalone/selectize.min.js';

import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js';

import axios from 'axios';

// Superagent
const request = require('superagent-defaults')();
const csrfToken = document.querySelector('meta[name=csrf_token]').getAttribute('content');

request.set('X-CSRF-TOKEN', csrfToken);
global.request = request;

// Main Vue instance
require('./blog');
require('./initPhotoswipe.js');

(function ($) {
    $(document).ready(() => {
        var editor = window.CKEDITOR;

        var getSession = function () {
            var url_part = '';
            var matches = document.cookie.match(/ASPSESSION[A-Z]{10}=[A-Z]{5}([A-Z]{15})\w+;/);

            if (matches == null) return url_part;

            if (matches.length == 2) url_part = '&sess=' + matches[1];

            return url_part;
        };

        var checkNotifications = function () {
            $.getJSON(
                'https://' +
                    $('meta[name=base_url]').attr('content') +
                    '/includes/ajax/notifications.asp?rnd=' +
                    Math.random() +
                    getSession(),
                function (data) {
                    setTimeout(checkNotifications, 30000);
                }
            );
        };

        var updateMessages = function () {
            $.getJSON('/min-sida/api/get-new-messages', function (data) {
                console.log(data);

                if (data.posts > 0) {
                    if ($('#header-message-badge').length) {
                        $('#header-message-badge').html(data.posts);
                    } else {
                        $('#header-mail-icon a').append(
                            '<span id="header-message-badge" class="badge">' + data.posts + '</span>'
                        );
                    }
                }

                if (data.notifications > 0) {
                    if ($('#header-notifications-badge').length) {
                        $('#header-notifications-badge').html(data.notifications);
                    } else {
                        $('#header-notification-icon a').append(
                            '<span id="header-notifications-badge" class="badge">' +
                                data.notifications +
                                '</span>'
                        );
                    }
                }

                setTimeout(updateMessages, 30000);
            });
        };

        if ($('.navbar #user-is-signed-in').length) {
            updateMessages();
        }

        if (getSession()) {
            checkNotifications();
        }

        $('.recipes--type .recipes--type--list').each(function (index) {
            if ($(this).height() > 163) {
                $(this).after('<a href="#" class="show-more">Visa fler</a>');
                $(this).attr('data-original-height', $(this).height());
                $(this).css('height', '163px');
            }
        });

        $(document).on('click', '.recipes--type .show-more', function (e) {
            e.preventDefault();
            var list = $(this).prev();
            var orginalHeight = list.attr('data-original-height');
            list.animate({ height: orginalHeight + 'px' }, 200);
            $(this).text('Dölj');
            $(this).removeClass('show-more');
            $(this).addClass('hide-more');
        });

        $(document).on('click', '.recipes--type .hide-more', function (e) {
            e.preventDefault();
            var list = $(this).prev();
            list.animate({ height: '163px' }, 200);
            $(this).text('Visa fler');
            $(this).removeClass('hide-more');
            $(this).addClass('show-more');
        });

        $(document).on('click', function (e) {
            // Hide menu if click outside
            if (!$(e.target).closest('.header—nav-button').length) {
                $('.header—nav-button').removeClass('button-active');
                $('.header—nav-list').removeClass('active');
            }
        });

        $('#mobile-nav').on('click', '.back a', function (e) {
            if (history.length) {
                history.back();
                e.preventDefault();
            }
        });

        $('.header—nav').on('click', '.header—nav-button', function (e) {
            $(this).toggleClass('button-active');
            $('.header—nav-list').toggleClass('active');
        });

        $('#recipe-comment-form').on('submit', function (e) {
            if (
                $('#recipe-comment-form').find('input[name=rating]:checked').length == 0 &&
                CKEDITOR.instances['recipe-comment-message'].getData().length == 0
            ) {
                e.preventDefault();
            }
        });

        $('.post .meta .delete').on('click', function (e) {
            e.preventDefault();
            bootbox.confirm('Är du säker på att du vill ta bort inlägget?', function (result) {
                if (result) window.location.replace($(e.target).attr('href'));
            });
        });

        $(document).on(
            'click',
            '.threads .post .meta .delete-forum, .threads .admin-bar .delete.admin-action-thread',
            function (e) {
                e.preventDefault();

                let message = 'Vill du verkligen radera denna tråd?';

                if ($(this).data('type') === 'group') {
                    message = 'Vill du verkligen radera denna grupp?';
                }

                let target = $(e.target);
                let form = $(this).parents('form');

                bootbox
                    .confirm({
                        message: message,
                        callback: function (result) {
                            if (result) {
                                if (target.is('a')) {
                                    window.location.replace($(e.target).attr('href'));
                                } else {
                                    form.submit();
                                }
                            }
                        }
                    })
                    .init(function () {
                        $('.modal-footer .btn.btn-primary').text('Radera');
                        $('.modal-footer .btn.btn-default').text('Avbryt');
                    });
            }
        );

        $(document).on('click', '.measurement-delete-all', function (e) {
            e.preventDefault();

            let message = 'Vill du verkligen radera alla mått?';

            bootbox
                .confirm({
                    message: message,
                    callback: function (result) {
                        if (result) {
                            window.location.replace(
                                window.location.origin +
                                    '/min-sida/installningar/remove-all-weight-measurement'
                            );
                        }
                    }
                })
                .init(function () {
                    $('.modal-footer .btn.btn-primary').text('Radera');
                    $('.modal-footer .btn.btn-default').text('Avbryt');
                });
        });

        setTimeout(function () {
            $('.alert-success').fadeOut();
        }, 3000);

        $('.user-story').slick({
            prevArrow: $('.icon-chevron-left'),
            nextArrow: $('.icon-chevron-right')
        });

        $('.meal--toggle-ingredients').on('click', function () {
            $(this).toggleClass('show-ingredients');
            $(this).parents('.meal--actions').next().toggleClass('show');
        });

        $('.quote-link').click(function (e) {
            e.preventDefault();

            $.ajax({
                url: '/forum/api/post',
                type: 'POST',
                data: {
                    _token: csrfToken,
                    model_id: $(this).data('id'),
                    type: $(this).data('type')
                },
                dataType: 'JSON',
                success: function (data) {
                    // console.log(data)
                    var returnSrting = `
                    <div class="quote">
                            <div class="author">${data.user.UserName} skrev den ${data.updated_at} </div>

                            <div class="quote-string">${data.content}</div>
                    </div>
                    <p></p>`;

                    editor.instances['body'].setData(returnSrting);

                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $('#cke_body').offset().top
                        },
                        10
                    );
                    // editor.instances['body'].execCommand( 'Enter' );
                    // editor.instances['body'].execCommand( 'Enter' );
                }
            });
        });

        $(document).on('click', '.delete-item', function (e) {
            e.preventDefault();

            const redirect = $(this).attr('data-redirect')
                ? $(this).attr('data-redirect')
                : window.location.href;

            const confirmed = confirm($(this).attr('data-confirm'));

            if (confirmed) {
                axios
                    .delete($(this).attr('href'), {
                        headers: {
                            'X-CSRF-TOKEN': csrfToken,
                            Accept: 'application/json'
                        }
                    })
                    .then(() => {
                        location.replace(redirect);
                    })
                    .catch((error) => {
                        console.error(error.response ?? error);
                    });
            }
        });

        $('.delete-message').on('click', function (e) {
            e.preventDefault();

            let confirmed = confirm('Är du säker på att du vill ta bort meddelandet');

            console.log(confirmed);

            if (confirmed) {
                $.getJSON($(this).attr('href'), function (data) {
                    location.reload();
                });
            }
        });

        let options = $('#forum_category option');

        let challange = $.map(options, function (option) {
            if (option.label === 'Utmaningar') {
                return option;
            }
        });

        $('#add_challange').on('change', function (e) {
            //den är i checkad
            if ($(this).prop('checked')) {
                $('#forum_category').find('option').remove().end().append(challange);
            } else {
                $('#forum_category').find('option').remove().end().append(options);
                $('#forum_category').val($('#forum_category option:first').val());
            }
        });

        $('.commit-challange').on('click', function (e) {
            e.preventDefault();

            $('.post .popup-on-challange').toggleClass('show');
        });

        var windowsize = $(window).width();

        $(window).resize(function () {
            windowsize = $(window).width();
        });

        $('.popup-on-challange .btn, .popup-on-challange .close-pop-up').on('click', function (e) {
            e.preventDefault();

            let values = {
                challange_id: $('.popup-on-challange').data('challange-id'),
                interval: $('.popup-on-challange').data('challange-interval'),
                thread_id: $('.popup-on-challange').data('thread-id'),
                current_id: $('.popup-on-challange').data('current-id'),
                comment:
                    windowsize > 992
                        ? $('.popup-on-challange .wrapper .form-group textarea#add_commnent_desktop').val()
                        : $('.popup-on-challange .wrapper .form-group textarea#add_commnent_mobile').val()
            };

            $.ajax({
                url: '/forum/submit-challange',
                type: 'POST',
                data: {
                    _token: csrfToken,
                    values: values,
                    type: $(this).data('type')
                },
                dataType: 'JSON',
                success: function (data) {
                    location.reload();
                }
            });
        });

        $('.datetimepicker').datetimepicker({
            locale: 'sv',
            format: 'YYYY-MM-DD'
        });

        $('.add-measurement-date').datetimepicker({
            locale: 'sv',
            format: 'YYYY-MM-DD',
            maxDate: 'now',
            defaultDate: new Date()
        });

        $('.register-date').datetimepicker({
            locale: 'sv',
            format: 'YYYY-MM-DD',
            minDate:
                $('.register-date').find('input').val() == ''
                    ? new Date().setDate(new Date().getDate() + 1)
                    : $('.register-date').find('input').val()
        });

        $('.promo .promo-code').on('click', function (e) {
            e.preventDefault();

            $(this).siblings('.form-group').toggleClass('show-promo');
        });

        $('#welcome-form-registration #username').on('change', function (e) {
            e.preventDefault();

            let userField = $(this).val();

            if (!/^[a-zåäöÅÄÖA-Z0-9]{3,8}$/.test(userField)) {
                $('#alert-box').show();
                $('#alert-box').text('Användarnamnet ska vara 3 till 8 bokstäver/siffror');
            } else {
                $('#alert-box').hide();

                $.ajax({
                    url: '/api/check-user-exists',
                    type: 'POST',
                    data: {
                        _token: csrfToken,
                        user_name: userField
                    },
                    dataType: 'JSON',
                    success: function (data) {
                        if (data !== 'OK') {
                            $('#alert-box').show();
                            $('#alert-box').text(data);
                        } else {
                            $('#alert-box').hide();
                        }
                    }
                });
            }
        });

        $("input[name='type-of-purchase']").on('click', function () {
            if (
                $('#diet-and-training-kickstart').is(':checked') ||
                $('#diet-and-training-all-inclusive').is(':checked')
            ) {
                $('.training-schedule').show();
            } else {
                $('.training-schedule').hide();
            }
        });

        if ($("input[name='type-of-purchase']").is(':checked')) {
            if (
                $('input[name="type-of-purchase"]:checked').val() === 'diet-and-training-kickstart' ||
                $('input[name="type-of-purchase"]:checked').val() === 'diet-and-training-all-inclusive'
            ) {
                $('.training-schedule').show();
            }
        }

        $('#promo-code').on('input', function () {
            if ($(this).val() === '') {
                $('#add-promo').prop('disabled', false);
            }
        });

        $('#add-promo').on('click', function (e) {
            e.preventDefault();

            $.ajax({
                url: '/api/add-promo',
                type: 'POST',
                data: {
                    _token: csrfToken,
                    promo_code: $('#promo-code').val()
                },
                dataType: 'JSON',
                success: function (data) {
                    if (data.code == true) {
                        // $('.promo-form-group').hide();
                        // $('.promo-code').hide();
                        $('.promo-code').addClass('promo-hide');
                        $('.promo-form-group').addClass('promo-hide');

                        $('#cart-form').append(
                            '<input id="promo-code-value" type="hidden" name="promo_code" value="' +
                                $('#promo-code').val() +
                                '" />'
                        );

                        if (data.message) {
                            $('#promo-message').html(`<span id="remove-promo">x</span> ${data.message}`);
                        }
                    } else {
                        if (data.message) {
                            $('#promo-message').text(data.message);
                        }
                    }
                }
            });
        });

        $(document).on('click', '#remove-promo', function (e) {
            $.ajax({
                url: '/api/remove-promo',
                type: 'GET',
                dataType: 'JSON',
                success: function (data) {
                    if (data) {
                        // console.log(data)
                        $('.promo-code').removeClass('promo-hide');
                        $('.promo-form-group').removeClass('promo-hide');
                        $('#promo-message').html('');
                        $('#promo-code-value').remove();
                    }
                }
            });
        });

        // cart in steps
        //  if($('#type-kickstart').length || $('#type-plus').length || $('#type-all-inclusive').length){

        //     $('#move-step-2').on('click', function(e){
        //         e.preventDefault();
        //         $('.checkout-part.part-1').hide();
        //         $('.checkout-part.part-2').show();
        //         $('.new-version-page-header .header—nav-item h3').text('Steg 2 av 3');
        //     });

        //  }

        $('#members').on('click', function (e) {
            e.preventDefault();

            const target = $(e.target);
            const link = target.is('span') || target.is('svg') ? target.parent() : target;

            $.ajax({
                url: '/api/check-allowed-premium',
                type: 'GET',
                dataType: 'JSON',
                success: function (data) {
                    if (data) {
                        window.location.replace(link.attr('href'));
                    } else {
                        if (
                            window.confirm(
                                'Du behöver vara plusmedlem för att komma åt vissa funktioner på denna sidan. Uppgradera ditt medlemskap under Min Profil.'
                            )
                        ) {
                            window.location.replace(link.attr('href'));
                        }
                    }
                }
            });
        });

        $(function () {
            let $desktopMenu = $('.desktop-navbar nav.navbar');
            let $mobileMenu = $('.mobile-navbar.navbar-container');

            const SHADOW_THRESHOLD = 25;

            function toggleDesktop(scrollPos) {
                if (scrollPos > 10) {
                    $desktopMenu.addClass('animate');
                } else {
                    $desktopMenu.removeClass('animate');
                }

                if (scrollPos > SHADOW_THRESHOLD) {
                    $desktopMenu.addClass('has-shadow');
                } else {
                    $desktopMenu.removeClass('has-shadow');
                }
            }

            function toggleMobile(scrollPos) {
                if (scrollPos > 0) {
                    $mobileMenu.addClass('animate');
                } else {
                    $mobileMenu.removeClass('animate');
                }
            }

            const initialScroll = $(window).scrollTop();

            if (window.innerWidth >= 992) {
                toggleDesktop(initialScroll);
            } else {
                toggleMobile(initialScroll);
            }

            $(window).on('scroll', function () {
                const scrollPos = window.scrollY;

                if (window.innerWidth >= 992) {
                    toggleDesktop(scrollPos);
                } else {
                    toggleMobile(scrollPos);
                }
            });

            $(window).on('resize', function () {
                const scrollPos = window.scrollY;

                $desktopMenu = $('.desktop-navbar nav.navbar');
                $mobileMenu = $('.mobile-navbar.navbar-container');

                if (window.innerWidth >= 992) {
                    toggleDesktop(scrollPos);
                } else {
                    toggleMobile(scrollPos);
                }
            });
        });

        if (
            location.pathname.includes('information/matdagboken/kontakta-oss') &&
            location.hash !== '#hs-chat-open'
        ) {
            location.hash = '#hs-chat-open';
        }

        const tabPages = ['/matdagboken/livsmedel/redigera', '/matdagbok/livsmedel/redigera'];

        if (tabPages.some((item) => location.pathname.includes(item)) && location.hash !== '') {
            const tab = location.hash.replace('#', '');

            $('.nav-tabs a[href="#' + tab + '"]').tab('show');
        }

        if ($('.time-picker').length) {
            $('.time-picker').datetimepicker({
                locale: 'sv',
                format: 'HH:mm'
            });
        }

        if ($('.date-picker').length) {
            $('.date-picker').datetimepicker({
                locale: 'sv',
                format: 'YYYY-MM-DD HH:mm'
            });
        }
    });
})(jQuery);

function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=0';
}
